// Shared UI bits for the Heart sub-tabs.

export function HrStat({
  label,
  value,
  unit,
  accent,
}: {
  label: string;
  value: number | null | undefined;
  unit?: string;
  accent?: boolean;
}) {
  const show = value != null;
  return (
    <div className="rounded-md border border-ink-line bg-canvas px-2 py-2 text-center">
      <div className="text-[10px] uppercase tracking-wider text-ink-subtle">{label}</div>
      <div className={`mt-0.5 font-display text-lg tabular-nums ${accent ? "text-accent" : "text-ink"}`}>
        {show ? value : "—"}
      </div>
      {show && unit && <div className="text-[10px] text-ink-subtle">{unit}</div>}
    </div>
  );
}

/** "1h 25m" / "45m" from minutes. */
export function fmtMins(min: number): string {
  if (min <= 0) return "0m";
  const h = Math.floor(min / 60);
  const m = Math.round(min % 60);
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
}
